import { render, staticRenderFns } from "./ElementScalePartSingleTableColumn.vue?vue&type=template&id=6b6b7c96"
import script from "./ElementScalePartSingleTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScalePartSingleTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports